'use client'
import {
  ContentfulMedia_default,
  ThemeButton_default
} from "./chunk-XIZE6A22.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/buttons/ContentfulButton.tsx
import { Link } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var ContentfulButton = (_a) => {
  var _b = _a, { button } = _b, props = __objRest(_b, ["button"]);
  var _a2, _b2, _c;
  const noLink = !button.href || button.href === "#";
  const isExternal = (_a2 = button.href) == null ? void 0 : _a2.startsWith("http");
  return /* @__PURE__ */ jsxs(
    ThemeButton_default,
    __spreadProps(__spreadValues({
      as: noLink ? "button" : Link,
      href: button.href,
      target: isExternal ? "_blank" : void 0,
      rel: isExternal ? "noopener noreferrer" : void 0,
      "aria-label": button.label || "",
      theme: button.theme,
      shape: button.shape,
      arrow: button.arrow
    }, props), {
      children: [
        ((_b2 = button.icon) == null ? void 0 : _b2.url) && button.iconPosition === "left" && /* @__PURE__ */ jsx(ContentfulMedia_default, { className: "shrink-0", media: button.icon, fit: "pad" }),
        button.label,
        ((_c = button.icon) == null ? void 0 : _c.url) && button.iconPosition === "right" && /* @__PURE__ */ jsx(ContentfulMedia_default, { className: "shrink-0", media: button.icon, fit: "pad" })
      ]
    })
  );
};
var ContentfulButton_default = ContentfulButton;

export {
  ContentfulButton_default
};
//# sourceMappingURL=chunk-2YBW2YZW.mjs.map